import React from 'react';
const services = [{
  title: 'Traditional Braces & Orthodontics',
  desc: 'Focus on structural alignment for all ages using time-tested methods for perfect results.',
  img: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Invisalign Clear Aligners',
  desc: 'Platinum discrete styling lookbook. Straighten your teeth invisibly with custom-made aligners.',
  img: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Porcelain Veneers',
  desc: 'Complete smile transformations and aesthetic shaping for a flawless, natural appearance.',
  img: 'https://images.unsplash.com/photo-1460672985063-6764ac8b9c74?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Crowns & Bridges',
  desc: 'Advanced permanent restorative dentistry to restore function and beauty to your smile.',
  img: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&q=80&w=800'
}];
export function Services() {
  return <section id="services" className="py-24 bg-slate-50" data-id="element-197">
      <div className="max-w-7xl mx-auto px-4" data-id="element-198">
        <h2 className="text-3xl font-bold text-[#0F2C59] mb-12 text-center tracking-tight" data-id="element-199">
          OUR FULL-SERVICE TREATMENT SUITE
        </h2>

        <div className="grid md:grid-cols-4 gap-6" data-id="element-200">
          {services.map((service, idx) => <div key={idx} className="bg-white rounded-[12px] overflow-hidden shadow-sm hover:shadow-md transition-shadow group" data-id="element-201">
              <div className="h-48 overflow-hidden" data-id="element-202">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-203" />
              </div>
              <div className="p-6" data-id="element-204">
                <h3 className="text-lg font-bold text-[#0F2C59] mb-3 leading-tight" data-id="element-205">
                  {service.title}
                </h3>
                <p className="text-sm text-slate-600 mb-6 leading-relaxed" data-id="element-206">
                  {service.desc}
                </p>
                <a href="#" className="text-sm font-bold text-[#4F709C] hover:text-[#0F2C59] flex items-center gap-1 transition-colors" data-id="element-207">
                  View Pricing & Procedure Details →
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}